import { render, staticRenderFns } from "./cabinetAlarmRecord.vue?vue&type=template&id=c9b24560&"
import script from "./cabinetAlarmRecord.vue?vue&type=script&lang=js&"
export * from "./cabinetAlarmRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9b24560')) {
      api.createRecord('c9b24560', component.options)
    } else {
      api.reload('c9b24560', component.options)
    }
    module.hot.accept("./cabinetAlarmRecord.vue?vue&type=template&id=c9b24560&", function () {
      api.rerender('c9b24560', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iotLog/cabinetAlarmRecord/cabinetAlarmRecord.vue"
export default component.exports